const PRODUCTION_DOMAIN = "esavjetnik.mps.hr";

export const getEnvironmentBasedValue = <T>(whenProduction: T, whenNotProduction: T) =>
    window.location.hostname === PRODUCTION_DOMAIN ? whenProduction : whenNotProduction;

const PRODUCTION_E_POLJOPRIVREDA_URL = "https://epoljoprivreda.mps.hr/";
const NON_PRODUCTION_E_POLJOPRIVREDA_URL = "https://epoljoprivredatst.mps.hr/";

export const getEPoljoprivredaUrl = () =>
    getEnvironmentBasedValue(PRODUCTION_E_POLJOPRIVREDA_URL, NON_PRODUCTION_E_POLJOPRIVREDA_URL);
